<template>
  <div class="filters">
    <v-menu :close-on-click="false" :close-on-content-click="false" offset-x>
      <template v-slot:activator="{ on, attrs }">
        <span
          class="filters-icon"
          v-bind="attrs"
          v-on="on"
          dark
        >
          <v-icon>
            {{ filterIcon(attrs) }}
          </v-icon>
        </span>
      </template>
      <div class="filters-fields">
        <v-row class="select-category" no-gutters>
          <v-col>
            <v-btn
              @click="() => emitCategoryFilter('APPOINTMENT')"
              class="button-category-left"
              :class="isCategoryAppointment ? 'primary' : ''"
              :dark="isCategoryAppointment"
              outlined
              block
              dark
              >
                <v-icon v-if="isCategoryAppointment" small left>
                  mdi-map-marker-outline
                </v-icon>
                <span class="font-weight-medium body-2">
                  {{$t('mapDrawing.appointments')}}
                </span>
            </v-btn>
          </v-col>
          <v-col>
            <v-btn
              @click="() => emitCategoryFilter('GROUP')"
              class="button-category-right"
              :class="isCategoryGroup ? 'primary' : ''"
              :dark="isCategoryGroup"
              outlined
              block
            >
              <v-icon v-if="isCategoryGroup" small left>
                mdi-map-marker-multiple-outline
              </v-icon>
              <span class="font-weight-medium body-2">
                {{$t('mapDrawing.groups')}}
              </span>
            </v-btn>
          </v-col>
        </v-row>

        <v-text-field
          :label="$t('mapDrawing.search')"
          prepend-inner-icon="mdi-magnify"
          @keyup="emitSearchFilter"
          @click:clear="handleClearSearch"
          :loading="searchLoading"
          outlined
          hide-details
          clearable
          dense
        />

        <v-select
          v-model="selectedStatus"
          @change="emitStatusFilter"
          :label="$t('mapDrawing.status')"
          :items="statusList"
          class="filter-input"
          item-value="value"
          item-text="label"
          hide-details
          clearable
          outlined
          multiple
          dense
        />

        <v-autocomplete
          v-if="isCategoryAppointment"
          :items="serviceTypes"
          @change="emitTypeFilter"
          :label="$t('mapDrawing.services')"
          class="filter-input"
          item-value="value"
          item-text="name"
          hide-no-data
          hide-details
          clearable
          outlined
          multiple
          dense
        />

        <!-- <v-autocomplete
          @change="emitTypeCustomer"
          :search-input.sync="customerSearch"
          :items="customers"
          label="Customer"
          class="filter-input"
          item-value="id"
          item-text="name"
          prepend-inner-icon="mdi-magnify"
          hide-no-data
          hide-details
          clearable
          outlined
          multiple
          dense
        /> -->

        <v-autocomplete
          v-if="isAdminOrPartner"
          v-model="hostsIds"
          @change="emitTypeHost"
          :search-input.sync="hostsSearch"
          :items="hostSearchResults"
          :loading="hostsLoading"
          :label="$t('mapDrawing.hosts')"
          class="filter-input"
          item-value="id"
          item-text="name"
          prepend-inner-icon="mdi-magnify"
          hide-no-data
          hide-details
          clearable
          outlined
          multiple
          dense
        />

        <v-autocomplete
          v-if="isAdminOrPartner"
          v-model="realEstate"
          @change="emitTypeRealEstate"
          :search-input.sync="realEstateSearch"
          :items="realEstateList"
          :label="$t('mapDrawing.customers')"
          class="filter-input"
          item-value="id"
          item-text="name"
          prepend-inner-icon="mdi-magnify"
          hide-no-data
          hide-details
          clearable
          outlined
          multiple
          dense
        />

        <v-autocomplete
          v-show="realEstate && realEstate.length"
          @change="emitTypeBranch"
          :search-input.sync="branchSearch"
          :items="branches"
          :label="$t('mapDrawing.branches')"
          class="filter-input"
          item-value="id"
          item-text="name"
          prepend-inner-icon="mdi-magnify"
          hide-no-data
          hide-details
          clearable
          outlined
          multiple
          dense
        />

        <v-row no-gutters>
          <v-col>
            <v-menu v-model="menuStartDate" :close-on-content-click="false" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="startDateLabel"
                  prepend-inner-icon="mdi-calendar-today-outline"
                  :label="$t('mapDrawing.startDate')"
                  class="filter-input"
                  v-bind="attrs"
                  v-on="on"
                  hide-details
                  outlined
                  dense
                />
              </template>
              <v-date-picker
                v-model="startDate"
                @change="emitStartDateFilter"
                color="primary"
                :locale="localeLanguage"
                scrollable
                no-title
              />
            </v-menu>
          </v-col>
          <v-col cols="1"></v-col>
          <v-col>
            <v-menu v-model="menuEndDate" :close-on-content-click="false" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="endDateLabel"
                  prepend-inner-icon="mdi-calendar-today-outline"
                  :label="$t('mapDrawing.endDate')"
                  class="filter-input"
                  v-bind="attrs"
                  v-on="on"
                  hide-details
                  outlined
                  dense
                />
              </template>
              <v-date-picker
                v-model="endDate"
                @change="emitEndDateFilter"
                :locale="localeLanguage"
                :min="minDate"
                color="primary"
                scrollable
                no-title
              />
            </v-menu>
          </v-col>
        </v-row>

        <v-select
          v-if="isCategoryAppointment"
          @change="emitTimeFilter"
          :items="hours"
          :label="$t('mapDrawing.time')"
          item-value="value"
          item-text="label"
          hide-details
          clearable
          outlined
          dense
        />

        <v-autocomplete
          v-if="isCategoryAppointment"
          :items="confirmedOptions"
          @change="emitConfirmedFilter"
          :label="$t('mapDrawing.confirmed')"
          class="filter-input"
          item-value="value"
          item-text="label"
          hide-no-data
          hide-details
          clearable
          outlined
          dense
        />

        <v-autocomplete
          v-if="isCategoryAppointment && isAdminOrPartner"
          :items="confirmationEmailSentOptions"
          @change="emitConfirmationEmailSentFilter"
          :label="$t('mapDrawing.confirmationSent')"
          class="filter-input"
          item-value="value"
          item-text="label"
          hide-no-data
          hide-details
          clearable
          outlined
          dense
        />

        <v-switch
          v-if="isCategoryAppointment"
          v-model="showGroupedAppointments"
          @change="emitShowHideGroupedAppointments"
          :label="$t('mapDrawing.showGroupedAppointments')"
          class="switch"
          color="realEstate"
          hide-details
          inset
        />
      </div>
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import { serviceTypes } from '@/util/enums'
import { appointmentPartnerStatus, groupPartnerStatus } from '@/util/enums'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { formatDateWithTimezone }  from '@/util/catalog'

const DATE_ONLY_FORMAT = 'DD/MM/YYYY'
const DEFAULT_APPOINTMENT_STATUSES = ['DRAFT', 'REJECTED']
const DEFAULT_GROUP_STATUSES = ['OPEN', 'ACCEPTED', 'DONE', 'CANCELED']

export default {
  name: 'MapFilters',

  computed: {
    ...mapGetters(['customers', 'branches', 'realEstateList', 'hostSearchResults']),

    localeLanguage() {
      return localStorage.getItem('user_language') ?? 'pt-BR'
    },

    startDateLabel() {
      return this.startDate ? moment(this.startDate).format(DATE_ONLY_FORMAT) : this.initialStartDateLabel
    },

    endDateLabel() {
      return this.endDate && moment(this.endDate).format(DATE_ONLY_FORMAT)
    },

    initialStartDateLabel() {
      return moment().add(-45, 'days').format(DATE_ONLY_FORMAT)
    },

    isCategoryAppointment() {
      return this.activeCategory === 'APPOINTMENT'
    },

    isCategoryGroup() {
      return this.activeCategory === 'GROUP'
    },

    statusList() {
      return this.isCategoryAppointment ? appointmentPartnerStatus : groupPartnerStatus
    },

    minDate() {
      return this.startDate ? this.startDate : moment().add(-45, 'days').format('YYYY-MM-DD')
    },

    isAdminOrPartner() {
      const roles = localStorage.getItem('access_roles')
      const userRoles = roles?.split(',')
      return userRoles?.includes('ROLE_ADMIN') || userRoles?.includes('ROLE_PARTNER')
    },
  },

  methods: {
    ...mapActions(['fetchCustomers', 'fetchBranchBySearchText', 'fetchRealEstatesBySearchText', 'fetchHostsBySearchText']),
    ...mapMutations(['setFilters']),

    handleClearSearch() {
      this.$emit('filter',  { search: '' })
    },

    emitCategoryFilter(category) {
      this.activeCategory = category
      this.selectedStatus = category === 'APPOINTMENT' ? [...DEFAULT_APPOINTMENT_STATUSES] : [...DEFAULT_GROUP_STATUSES]
      this.$emit('filter', { category, status: this.selectedStatus })
    },

    emitStatusFilter(status) {
      this.$emit('filter', { status: status || [] })
    },

    emitSearchFilter(event) {
      this.searchLoading = true
      if (this._timer) {
        clearTimeout(this._timer)
        this._timer = null
      }

      this._timer = setTimeout(() => {
        this.$emit('filter',  { search: event.target.value })
        this.searchLoading = false
      }, 1000)
    },

    emitConfirmationEmailSentFilter(value) {
      this.$emit('filter',  { confirmationEmailSent: value })
    },

    emitConfirmedFilter(value) {
      this.$emit('filter',  { confirmed: value })
    },

    emitTypeFilter(value) {
      this.$emit('filter', { serviceType: value })
    },

    emitStartDateFilter(value) {
      this.$emit('filter', { startDate: formatDateWithTimezone(value + 'T00:00:00') })
    },

    emitEndDateFilter(value) {
      this.$emit('filter', { endDate: formatDateWithTimezone(value + 'T23:59:59') })
    },

    emitTimeFilter(value) {
      this.$emit('filter', {
        startTime: value?.startTime,
        endTime: value?.endTime
       })
    },

    emitTypeHost(value) {
      this.$emit('filter', { hostsIds: value })
    },

    emitTypeCustomer(value) {
      this.$emit('filter', { clients: value })
    },

    emitTypeBranch(value) {
      this.$emit('filter', { branches: value })
    },

    emitTypeRealEstate(value) {
      this.$emit('filter', { realEstate: value })
    },

    emitShowHideGroupedAppointments(value) {
      this.$emit('showHideGroupedAppointments', value)
    },

    filterIcon(attrs) {
      return attrs['aria-expanded'] === 'false' ? 'mdi-filter-outline' : 'mdi-filter'
    }
  },

  watch: {
    customerSearch(value) {
      if (value?.length > 3) {
        clearTimeout(this._timer)
        this.setFilters({ search: value })

        this._timer = setTimeout(() => {
          this.fetchCustomers()
        }, 1000)
      }
    },

    branchSearch(value) {
      if (value?.length > 3) {
        this.hostsLoading = true
        clearTimeout(this._timer)

        this._timer = setTimeout(() => {
          this.fetchBranchBySearchText({
            searchText: value,
            realEstatesIds: this.realEstate
          }).finally(() => this.hostsLoading = false)
        }, 1000)
      }
    },

    realEstateSearch(value) {
      if (value?.length > 3) {
        clearTimeout(this._timer)

        this._timer = setTimeout(() => {
          this.fetchRealEstatesBySearchText(value)
        }, 1000)
      }
    },

    hostsSearch(value) {
      if (value?.length > 3) {
        clearTimeout(this._timer)

        this._timer = setTimeout(() => {
          this.fetchHostsBySearchText(value)
        }, 1000)
      }
    },
  },

  data() {
    return {
      _timer: null,
      hostsSearch: null,
      branchSearch: null,
      customerSearch: null,
      realEstateSearch: null,
      selectedStatus: [...DEFAULT_APPOINTMENT_STATUSES],

      serviceTypes,

      menu: false,
      branchLoading: false,
      hostsLoading: false,
      searchLoading: false,

      activeCategory: 'APPOINTMENT',

      startDate: '',
      endDate: '',
      menuStartDate: false,
      menuEndDate: false,
      showGroupedAppointments: false,
      realEstate: null,
      hostsIds: null,
      confirmedOptions: [
        {
          label: 'Confirmed',
          value: true
        },
        {
          label: 'Not confirmed',
          value: false
        },
      ],
      confirmationEmailSentOptions: [
        {
          label: 'Sent',
          value: true
        },
        {
          label: 'Not sent',
          value: false
        },
      ],
      hours: [
        {
          label: '08:00 AM - 11:59 AM',
          value: {
            startTime: '8:00-03:00',
            endTime: '11:59-03:00'
          }
        },
        {
          label: '12:00 PM - 05:59 PM',
          value: {
            startTime: '12:00-03:00',
            endTime: '17:59-03:00',
          }
        },
        {
          label: '06:00 PM - 23:59 PM',
          value: {
            startTime: '18:00-03:00',
            endTime: '23:59-03:00',
          }
        },
        {
          label: '00:00 AM - 07:59 AM',
          value: {
            startTime: '00:00-03:00',
            endTime: '07:59-03:00',
          }
        },
      ],

      timezone: moment.tz.guess(),
    }
  },
}
</script>

<style scoped>
.filters {
  position: absolute;
  left: 5px;
  top: 5px;
}

.filters-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border-radius: 4px;
  background-color: white;
  box-shadow: -2px 6px 12px 0 rgba(0, 0, 0, 0.2) !important;
}

.filters-icon:hover i {
  color: #000 !important;
}

.filters-icon .v-icon {
  font-size: 22px;
}

.filters-fields {
  display: flex;
  flex-direction: column;
  width: 320px;
  gap: 15px;
  padding: 12px 10px;
  border-radius: 4px;
  background-color: white;
  overflow: hidden;
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.65);
  box-shadow: -2px 6px 12px 0 rgba(0, 0, 0, 0.2) !important;
}

.filter-input {
  font-size: 13px !important;
}

.filter-input i {
  font-size: 11px !important;
}

.v-menu__content {
  transform: translate(5px, -6px);
}

.button-category-left,
.button-category-right {
  border-color: #f37a76;
  color: #f37a76;
}

.button-category-left.primary,
.button-category-right.primary {
  color: #fff;
  border-color: #f37a76 !important;
}

.button-category-left {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.button-category-right {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.switch {
  margin-bottom: 10px;
}
</style>
